import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import './Pagination.css';

export function Pagination({ page, total, pageSize, onChange, className = '' }) {
  const totalPages = Math.ceil(total / pageSize);
  if (totalPages <= 1) return null;

  const from = (page - 1) * pageSize + 1;
  const to = Math.min(page * pageSize, total);

  return (
    <div className={`ui-pagination ${className}`}>
      <span className="ui-pagination__info">
        {from}–{to} из {total}
      </span>
      <div className="ui-pagination__btns">
        <button
          className="ui-pagination__btn"
          onClick={() => onChange(page - 1)}
          disabled={page <= 1}
          aria-label="Предыдущая"
        >
          <ChevronLeft size={16} />
        </button>
        <button
          className="ui-pagination__btn"
          onClick={() => onChange(page + 1)}
          disabled={page >= totalPages}
          aria-label="Следующая"
        >
          <ChevronRight size={16} />
        </button>
      </div>
    </div>
  );
}
